<template>
  <div @mouseleave="onSelectionChange">
    <vue-editor
      v-model="post"
      @imageAdded="handleImageAdded"
      @selection-change="onSelectionChange"
    ></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  props: ["name", "validation", "content", "dropdown_name"],
  data() {
    return {
      post: this.content,
    };
  },
  methods: {
    onSelectionChange() {
      this.$emit("post", {
        name: this.name,
        value: this.post,
      });
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      console.log("ok");
      var formData = new FormData();
      formData.append("image", file);

      this.axios({
        url: "https://fakeapi.yoursite.com/images",
        method: "POST",
        data: formData,
      })
        .then((result) => {
          let url = result.data.url; // Get url from response
          console.log(url);
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>